import React from 'react'

import {NvSpinner} from '@invitae/ids-react'

import styles from './AppLoaderLoadingIndicator.module.scss'

export const AppLoaderLoadingIndicator: React.FunctionComponent = () => (
  <div className={styles.loadingContainer}>
    <NvSpinner isLoading={true} />
  </div>
)

export default AppLoaderLoadingIndicator
